<template>
    <div>
        <date-range-picker
            ref="picker"
            opens="left"
            v-model="filterDate"
            :show-dropdowns="true"
            :ranges="ranges"
            :append-to-body="true"
            :locale-data="localeData"
            @update="updateValues"
            control-container-class="form-control"
        >
            <template v-slot:input="picker" class="">
                <i class="fas fa-calendar mr-1"></i> {{ picker.startDate | moment('DD MMMM YYYY') }} - {{ picker.endDate | moment('DD MMMM YYYY') }}
            </template>
        </date-range-picker>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    components: {
        DateRangePicker
    },
    props: [
        'locale',
        'startDate',
        'endDate'
    ],
    data() {
        return {
            filterDate : {
                startDate: this.startDate,
                endDate: this.endDate
            }
        }
    },
    created() {
        this.$moment.locale(this.locale)
    },
    computed: {
        localeData: function () {
            switch (this.locale) {
                case 'en':
                    return {
                        direction: 'ltr',
                        format: 'mm/dd/yyyy',
                        separator: ' - ',
                        applyLabel: 'Apply',
                        cancelLabel: 'Cancel',
                        weekLabel: 'W',
                        customRangeLabel: 'Custom Range',
                        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                        firstDay: 1
                    }
                    break;

                case 'pt-BR':
                    return {
                        direction: 'ltr',
                        format: 'dd/mm/yyyy',
                        separator: ' - ',
                        applyLabel: 'Aplicar',
                        cancelLabel: 'Cancelar',
                        weekLabel: 'W',
                        customRangeLabel: 'Período Personalizado',
                        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                        firstDay: 1
                    }
                    break;

                case 'es':
                    return {
                        direction: 'ltr',
                        format: 'dd/mm/yyyy',
                        separator: ' - ',
                        applyLabel: 'Aplicar',
                        cancelLabel: 'Cancelar',
                        weekLabel: 'W',
                        customRangeLabel: 'Período Personalizado',
                        daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                        monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                        firstDay: 1
                    }
                    break;

                default:
                    return {
                        direction: 'ltr',
                        format: 'mm/dd/yyyy',
                        separator: ' - ',
                        applyLabel: 'Apply',
                        cancelLabel: 'Cancel',
                        weekLabel: 'W',
                        customRangeLabel: 'Custom Range',
                        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                        firstDay: 1
                    }
                    break;
            }
        },
        ranges: function() {

            let today = new Date()
            today.setHours(0, 0, 0, 0)
            let yesterday = new Date()
            yesterday.setDate(today.getDate() - 1)
            yesterday.setHours(0, 0, 0, 0);
            let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
            let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

            switch (this.locale) {
                case 'en':
                    return {
                        'Today' : [today, today],
                        'Yesterday' : [yesterday, yesterday],
                        'This Month': [thisMonthStart, thisMonthEnd],
                        'This Year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
                        'Last Month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
                    }
                    break;

                case 'pt-BR':
                    return {
                        'Hoje' : [today, today],
                        'Ontem' : [yesterday, yesterday],
                        'Este Mês': [thisMonthStart, thisMonthEnd],
                        'Este Ano': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
                        'Último Mês': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
                    }
                    break;

                case 'es':
                    return {
                        'Hoy' : [today, today],
                        'Ayer' : [yesterday, yesterday],
                        'Este Mes': [thisMonthStart, thisMonthEnd],
                        'Este Año': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
                        'El Mes Pasado': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
                    }
                    break;

                default:
                    return {
                        'Today' : [today, today],
                        'Yesterday' : [yesterday, yesterday],
                        'This Month': [thisMonthStart, thisMonthEnd],
                        'This Year': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
                        'Last Month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
                    }
                    break;
            }
        }
    },
    methods: {
        updateValues() {
            this.$emit('changeDate', this.filterDate)
            // axios.put('/change-date-tenant', this.filterDate)
            //     .then((result) => {
            //         location.reload();
            //     })
        },
    }
}
</script>

<style>

</style>
